import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';

export { UnsavedChangesGuard, UnsavedChangesGuardedForm } from './guards/unsaved-changes.guard';

export const GUARDS: any[] = [
	UnsavedChangesGuard
];
